import { gpCommon } from '../app';
import { ModalService, IUibModalInstance } from '../services/bootstrap-ui-modal';

import * as showdown from 'showdown';
import confirmationDialogTemplate from './confirmation-dialog.html';

export interface gpConfirmationDialogButton {
    caption: string;
    result: string;
}

export class gpConfirmationDialogButtons {
    public static Ok: gpConfirmationDialogButton = {
        caption: 'Ok', result: 'ok',
    };

    public static Cancel: gpConfirmationDialogButton = {
        caption: 'Cancel', result: 'cancel',
    };
}

interface gpConfirmationDialogOptionsBase {
    title: string;
    buttons: gpConfirmationDialogButton[];
    rememberPreferenceKey?: string;
    rememberPreferenceLabel?: string;
    rememberPreferenceInitialValue?: boolean;
}

interface gpConfirmationDialogOptionsPlain extends gpConfirmationDialogOptionsBase {
    mainInstruction: string;
}


interface gpConfirmationDialogOptionsMarkdown extends gpConfirmationDialogOptionsBase {
    mainInstructionMarkdown: string;
}

type gpConfirmationDialogOptions = gpConfirmationDialogOptionsPlain | gpConfirmationDialogOptionsMarkdown;


interface IConfirmationDialogScope extends ng.IScope {
    errors: any;
    title: string;
    bodyHtml: string;
    buttons: {
        caption: string; click: () => void;
    }[];
    rememberPreferenceEnabled: boolean;
    rememberPreferenceLabel: string;
    rememberPreferenceValue: boolean;
    rememberPreferenceInputId: string;
}

gpCommon.controller('gpConfirmationDialog', [
    '$scope',
    '$uibModalInstance',
    'options',
    function ($scope: IConfirmationDialogScope, $uibModalInstance: IUibModalInstance<string>, options: gpConfirmationDialogOptions) {

        $scope.errors = {};
        $scope.title = options.title;

        if ('mainInstructionMarkdown' in options) {
            $scope.bodyHtml = new showdown.Converter().makeHtml(options.mainInstructionMarkdown);
        } else {
            $scope.bodyHtml = options.mainInstruction;
        }

        const rememberPreferenceKey = options.rememberPreferenceKey || null;
        const rememberPreferenceLabel = options.rememberPreferenceLabel || 'Do not show again';

        let initialRememberValue = !!options.rememberPreferenceInitialValue;

        if (rememberPreferenceKey) {
            try {
                const storedValue = window.localStorage.getItem(rememberPreferenceKey);
                if (storedValue !== null) {
                    initialRememberValue = storedValue === 'true';
                }
            } catch (e) {
                // ignore storage access issues and fall back to provided default
            }
        }

        $scope.rememberPreferenceEnabled = !!rememberPreferenceKey;
        $scope.rememberPreferenceLabel = rememberPreferenceLabel;
        $scope.rememberPreferenceValue = initialRememberValue;
        $scope.rememberPreferenceInputId = rememberPreferenceKey
            ? rememberPreferenceKey.replace(/[^a-zA-Z0-9_-]/g, '-') + '-toggle'
            : 'gp-confirmation-dialog-toggle';

        $scope.buttons = options.buttons.map(srcBut => ({
            caption: srcBut.caption,
            click: () => {
                if (rememberPreferenceKey) {
                    try {
                        window.localStorage.setItem(
                            rememberPreferenceKey,
                            $scope.rememberPreferenceValue ? 'true' : 'false'
                        );
                    } catch (e) {
                        // ignore storage access issues
                    }
                }

                $uibModalInstance.close(srcBut.result);
            },
        }));
    }]);

export class ConfirmationDialogService {
    static $inject = ['gpModal'];
    static readonly serviceName = 'gpConfirmationDialogService';

    constructor(private readonly modalService: ModalService) {
    }

    public show(options: gpConfirmationDialogOptions) {

        const modalInstance = this.modalService.open<string>({
            animation: true,
            template: confirmationDialogTemplate,
            controller: 'gpConfirmationDialog',
            backdrop: true,
            backdropClass: 'gameplan-confirmation-dialog',
            windowClass: 'gameplan-confirmation-dialog',
            resolve: {
                options: (): gpConfirmationDialogOptions => options,
            },
        });

        return modalInstance.result;
    }
}

gpCommon.service(ConfirmationDialogService.serviceName, ConfirmationDialogService);

